export const text = {
  profilePicture: "Profile Picture",
  basicInfo: "Basic Information",
  editProfile: "Edit Profile",
  signUp: "Sign Up",
  alreadyHaveAccount: "Already have an Account?",
  dontHaveAccount: "Don't have any account ?",
  loginButton: "Login Account",
  login: "Login",
  forgotPassword: "Forgot Password ?",
  registerNow: "Register Now",
  enterConfirmPassword: "Enter Confirm Password",
  enterPassword: "Enter Password",
  enterNewPassword: "Enter New Password",
  selectCountry: "Select Country",
  enterZipCode: "Enter Zip Code",
  selectState: "Select State",
  enterCityName: "Enter City Name",
  enterFullName: "Enter Full Name",
  enterFullAddress: "Enter Full Address",
  phoneNumber: "Enter Phone Number",
  enterEmail: "Enter Email",
  enterLastName: "Enter Last Name",
  enterMiddleName: "Enter Middle Name",
  enterFirstName: "Enter First Name",
  welcome: "Welcome back !",
  registerTo: "Register to your account.",
  loginTo: "Login to your account.",
  backToLogin: "Back to Login",
  lostAccess: "Lost Access?",
  resetNow: "Reset password now.",
  deleteAccount: "Would you like to delete your account?",
  createNewPassword: "Create new password.",
  firstNameLabel: "First Name",
  middleNameLabel: "Middle Name",
  lastNameLabel: "Last Name",
  emailLabel: "Email",
  phoneLabel: "Phone",
  addressLabel: "Address",
  cityLabel: "City",
  stateLabel: "State",
  countryLabel: "Country",
  zipCodeLabel: "Zip Code",
  message: "Message",
  relationStatusSelect: "Select Marital Status",
  enterYourEmail: "Enter your email address to continue",
};
